var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { Decorator } from '../decorator';
export var Toggle = React.forwardRef(function ToggleComponent(_a, ref) {
    var hint = _a.hint, label = _a.label, error = _a.error, errorMessage = _a.errorMessage, id = _a.id, fieldError = _a.fieldError, requiredIndicator = _a.requiredIndicator, className = _a.className, props = __rest(_a, ["hint", "label", "error", "errorMessage", "id", "fieldError", "requiredIndicator", "className"]);
    return (React.createElement(Decorator, { id: id, className: className, error: error, errorMessage: errorMessage, hint: hint, fieldError: fieldError, requiredIndicator: requiredIndicator },
        React.createElement("div", { className: 'flex gap-2' },
            React.createElement("input", __assign({ className: 'peer opacity-0 absolute pointer-events-none disabled:hidden', id: id, type: "checkbox", ref: ref }, props)),
            React.createElement("label", { className: classNames('group relative inline-block h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out bg-gray-100 hover:bg-gray-200 peer-checked:bg-primary-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-100 peer-disabled:pointer-events-none peer-disabled:bg-gray-100'), htmlFor: id, "aria-hidden": "true" },
                React.createElement("span", { className: classNames('peer-checked:group-[]:translate-x-4 translate-x-0', 'pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out absolute top-0 left-px') })),
            label && React.createElement("label", { htmlFor: id, className: 'text-gray-700 text-sm font-medium' }, label))));
});
